import { createFileRoute } from "@tanstack/react-router";
import TemplatesSettingsPage from "@/components/settings/pages/TemplatesSettingsPage";

export const Route = createFileRoute("/settings/templates")({
  component: TemplatesSettingsPage,
});
